import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { cn } from "../../../lib/utils.js";
import "../shared/quiz-blank.js";
import { KatexText } from "../shared/katex-text.js";
import "react";
import "react-i18next";
import "../../../node_modules/.pnpm/hls.js@1.6.15/node_modules/hls.js/dist/hls.js";
import "../../../utils/quiz-parser.js";
import "../../../context/DevToolsContext.js";
import { PrintQuizTitle, getImageUrl, getStyles } from "./print-common.js";
function PairingPrint({
  quiz,
  number,
  showCorrectAnswers = false,
  correctAnswers,
  compact
}) {
  const s = getStyles(compact);
  const pairs = quiz.pairs;
  const maxRows = Math.max(pairs.left.length, pairs.right.length);
  const correctMatchMap = /* @__PURE__ */ new Map();
  if (showCorrectAnswers && correctAnswers) {
    correctAnswers.forEach((rightKey, leftIdx) => {
      if (!rightKey) return;
      const rightIdx = pairs.right.findIndex((r) => r.key === rightKey);
      if (rightIdx !== -1) correctMatchMap.set(leftIdx, rightIdx);
    });
  }
  return /* @__PURE__ */ jsxs("div", { className: cn(s.container, s.quizSection), children: [
    /* @__PURE__ */ jsx(PrintQuizTitle, { number, compact, children: /* @__PURE__ */ jsx(KatexText, { text: quiz.title }) }),
    /* @__PURE__ */ jsx(
      "div",
      {
        className: "w-full px-[40px]",
        style: { display: "grid", gridTemplateColumns: "200px 1fr 200px", gridAutoRows: "1fr", gap: "12px 0" },
        children: Array.from({ length: maxRows }).map((_, rowIdx) => {
          const leftItem = pairs.left[rowIdx];
          const rightItem = pairs.right[rowIdx];
          const leftImageUrl = (leftItem == null ? void 0 : leftItem.image) ? getImageUrl(leftItem.image) : null;
          const rightImageUrl = (rightItem == null ? void 0 : rightItem.image) ? getImageUrl(rightItem.image) : null;
          return /* @__PURE__ */ jsxs("div", { className: "contents", children: [
            /* @__PURE__ */ jsx(
              "div",
              {
                className: cn(
                  "bg-white border-[#ccc] border-[1.5px] border-solid rounded-[6px]",
                  "flex items-center justify-center min-h-[64px] px-[12px] py-[8px]"
                ),
                children: leftItem && /* @__PURE__ */ jsxs(Fragment, { children: [
                  leftImageUrl && /* @__PURE__ */ jsx("img", { src: leftImageUrl, alt: "pairing", className: "max-h-[28px] w-auto object-contain shrink-0" }),
                  leftItem.answer && /* @__PURE__ */ jsx("span", { className: cn("text-black", compact ? "text-[15px]" : "text-[14px]"), children: /* @__PURE__ */ jsx(KatexText, { text: leftItem.answer }) })
                ] })
              }
            ),
            /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between px-[10px]", children: [
              /* @__PURE__ */ jsx("span", { className: "size-[10px] rounded-full bg-[#ccc]" }),
              /* @__PURE__ */ jsx("span", { className: "size-[10px] rounded-full bg-[#ccc]" })
            ] }),
            /* @__PURE__ */ jsx(
              "div",
              {
                className: cn(
                  "bg-white border-[#ccc] border-[1.5px] border-solid rounded-[6px]",
                  "flex items-center justify-center min-h-[64px] px-[12px] py-[8px]"
                ),
                children: rightItem && /* @__PURE__ */ jsxs(Fragment, { children: [
                  rightImageUrl && /* @__PURE__ */ jsx("img", { src: rightImageUrl, alt: "pairing", className: "max-h-[28px] w-auto object-contain shrink-0" }),
                  rightItem.answer && /* @__PURE__ */ jsx("span", { className: cn("text-black", compact ? "text-[15px]" : "text-[14px]"), children: /* @__PURE__ */ jsx(KatexText, { text: rightItem.answer }) })
                ] })
              }
            )
          ] }, rowIdx);
        })
      }
    )
  ] });
}
export {
  PairingPrint
};
//# sourceMappingURL=pairing-print.js.map
